import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssuesHistoryEmployeeController',
            IssuesHistoryEmployeeController
        );

    /** @ngInject */
    function IssuesHistoryEmployeeController(
        $scope,
        $state,
        DateService,
        DownloadFileService,
        CompanyFactory,
        CompaniesFactory,
        BulkModeService
    ) {
        var vm = this;

        // -----------------------
        // Bulk Mode related stuff
        // -----------------------

        BulkModeService.attachBulkModeFunctions(vm, 'issues', 'id');

        function enableBulkMode() {
            vm.enableBulkMode();
        }

        // Bulk Actions

        vm.bulkIssuePrintout = function () {
            if (!vm.batchIsEmpty()) {
                CompaniesFactory.downloadIssuePrintout(
                    vm.companyId,
                    vm.batchItems.join(',')
                ).then(downloadFile);
            }
        };

        // EOT Bulk Mode

        /**
         * Delegates row click handling to appropriate handler depending
         * of the active mode.
         *
         * @param issueId
         */
        vm.handleRowClick = function (issueId) {
            showIssueDetails(issueId);
        };

        init();

        vm.changeOrdering = function (fieldName) {
            var newOrdering = vm.ordering.splice(0);
            var ascIndex = newOrdering.findIndex(i => i === fieldName);
            var descIndex = newOrdering.findIndex(i => i === `-${fieldName}`);

            if (descIndex > -1) {
                newOrdering = [];
            } else if (ascIndex > -1) {
                newOrdering = [`-${fieldName}`];
            } else {
                newOrdering = [fieldName];
            }
            vm.ordering = newOrdering;
        }

        vm.orderingIcon = function (fieldName) {
            var ascIndex = vm.ordering.findIndex(i => i === fieldName);
            var descIndex = vm.ordering.findIndex(i => i === `-${fieldName}`);

            if (descIndex > -1) {
                return "/assets/images/sort-desc-ico.png";
            } else if (ascIndex > -1) {
                return "/assets/images/sort-asc-ico.png";
            } else {
                return "";
            }
        }

        vm.clearFixedAtDateFilter = function () {
            vm.fixedAtFrom = null;
            vm.fixedAtTo = null;
        }

        function init() {
            const setupFlexMenusStructure = () => {
                vm.flexMenusStructure = [
                    [
                        {
                            name: 'Pobierz widok',
                            func: downloadXLSFile,
                            if: true,
                        },
                        {
                            name: 'Grupowe zaznaczanie zgłoszeń',
                            func: enableBulkMode,
                            if: vm.isManager,
                        },
                    ],
                ];
            };

            vm.areIssuesAvailable = true;
            vm.ordering = [];
            vm.readIssuesService = function (companyId, params) {
                // If CompaniesFactory.readIssues is not wrapped in that way then
                // this.$http in CompaniesFactory is not defined when paginator
                // try to fetch data.
                return CompaniesFactory.readIssues(companyId, params);
            };
            vm.years = DateService.generateYears(2016);
            vm.months = DateService.getMonths();
            vm.statuses = [
                { name: 'Zrealizowano', value: 'fixed' },
                { name: 'Odrzucono', value: 'rejected' },
            ];
            vm.params = setParams();

            getCompany().then(setupFlexMenusStructure);
        }

        function setParams() {
            var params = {
                page_size: (function () {
                    if (vm.params) {
                        return vm.params.page_size || 50;
                    }
                })(),
                page: (function () {
                    if (vm.params) {
                        return vm.params.page || 1;
                    }
                })(),
                status: vm.status,
                created_at_year: vm.selectedYear,
                created_at_month: vm.selectedMonth,
                active: false,
                search: vm.searchPhrase,
                customer: (function () {
                    if (vm.housingAssociation) {
                        return vm.housingAssociation.party_uuid;
                    }
                })(),
                fixed_at__from: vm.fixedAtFrom,
                fixed_at__to: vm.fixedAtTo,
                settlement: vm.settlement,
                issue_category: vm.category,
                assigned_to: vm.assignedTo,
                ordering: vm.ordering.join(","),
            };

            if (vm.customFieldFilters) {
                vm.customFieldFilters.forEach(function (customField) {
                    Object.assign(params, customField);
                });
            }

            return params;
        }

        function setWatcher() {
            $scope.$watchGroup(
                [
                    function () {
                        return vm.status;
                    },
                    function () {
                        return vm.selectedYear;
                    },
                    function () {
                        return vm.selectedMonth;
                    },
                    function () {
                        return vm.searchPhrase;
                    },
                    function () {
                        return vm.housingAssociation;
                    },
                    function () {
                        return vm.category;
                    },
                    function () {
                        return vm.settlement;
                    },
                    function () {
                        return vm.lastStatusDate;
                    },
                    function () {
                        return vm.fixedAtFrom;
                    },
                    function () {
                        return vm.fixedAtTo;
                    },
                    function () {
                        return vm.assignedTo;
                    },
                    function () {
                        return vm.customFieldFilters;
                    },
                    function() {
                        return vm.ordering;
                    }
                ],
                function () {
                    vm.params = setParams();
                    vm.params.page = 1;

                    getIssues();
                }
            );
        }

        function getIssues() {
            CompaniesFactory.readIssues(vm.companyId, vm.params).then(
                function (response) {
                    vm.areIssuesAvailable = true;
                    vm.issues = response.data;
                },
                function (error) {
                    if (error.status === 404) {
                        vm.areIssuesAvailable = false;
                    }
                }
            );
        }

        function getCompany() {
            return CompanyFactory.readCompany().then(function (response) {
                vm.isManager = response.data.manager;
                vm.companyId = response.data.organization.party_uuid;

                getClientsHousingAssociations();
                addAdditionalStatusesIfNeeded();
                setWatcher();
            });
        }

        function getClientsHousingAssociations() {
            CompaniesFactory.readHousingAssociations(vm.companyId, {
                page_size: 1000,
            }).then(function (response) {
                vm.clientsHousingAssociations = response.data.results;
            });
        }

        function addAdditionalStatusesIfNeeded() {
            CompaniesFactory.readCompanies(vm.companyId).then(function (
                response
            ) {
                if (response.data.estimate_status) {
                    vm.statuses.push({
                        name: 'Kosztorys',
                        value: 'estimate',
                    });
                }

                if (response.data.invoiced_status) {
                    vm.statuses.push({
                        name: 'Zafakturowano',
                        value: 'invoiced',
                    });
                }
            });
        }

        function showIssueDetails(issueId) {
            $state.go('company_employee.history_issue_list.issue_view', {
                issue_id: issueId,
            });
        }

        function downloadFile(httpFileResponse) {
            DownloadFileService.downloadFile(httpFileResponse);
        }

        function downloadXLSFile() {
            CompaniesFactory.downloadView(vm.companyId, vm.params).then(
                downloadFile
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/history/history.controller.ts